import { Flex } from '@lokalise/louis';

import { DropzoneColoredText } from './style';

export const AdditionalFilesIdleState = () => (
    <Flex align="center" direction="column" gap={3}>
        <p>
            Drag and drop or <DropzoneColoredText>select more</DropzoneColoredText> files to upload
        </p>
    </Flex>
);

export default AdditionalFilesIdleState;
